import React from "react";
import { Button, Modal, Form, notification, Input, Select, Radio } from "antd";
import { ApolloError } from "apollo-boost";
import { defaultFormLayout } from "../../common/Utils";
import NumberFormat from "react-number-format";
import { AsyncValid } from "../../common/AsyncValid";
import { observer } from "mobx-react";
import { familyStore } from "../../store/family/FamilyStore";

export const FamilyAddParent = observer(() => {
  const { addParent } = familyStore;
  const [form] = Form.useForm();

  const save = () => {
    if (!addParent.isNew && !addParent.searchUser) {
      form.setFields([
        {
          name: "email",
          errors: ["User not found."],
        },
      ]);
      return;
    }
    form.validateFields().then((values) => {
      addParent
        .save(values)
        .then((res) => {
          notification.success({
            message: `User ${values.firstName} created.`,
          });
          addParent.store.loadData();
          addParent.close();
        })
        .catch((err: ApolloError) => {
          if (err.graphQLErrors) {
            try {
              const json = JSON.parse(err.graphQLErrors[0].message);
              if (json.msg === "Duplicate email") {
                form.setFields([
                  {
                    name: "email",
                    errors: [
                      `User with the same email address was found: ${json.info} Division. If the user has moved, please contact the Managing Director to move the record to your division. Otherwise, please double check the email.`,
                    ],
                  },
                ]);
              }
            } catch {
              notification.error({
                message: err.graphQLErrors[0].message,
              });
            }
          }
        });
    });
  };

  const onShow = () => {
    addParent.show();
    form && form.resetFields();
  };

  const onTab = (e) => {
    form && form.resetFields(["firstName", "lastName", "mobile", "email"]);
    addParent.searchUser = null;
    addParent.isNew = e.target.value;
  };
  return (
    <>
      <Button onClick={() => onShow()}>Add Parent</Button>
      <Modal
        title={`Add a Parent`}
        visible={addParent.showDlg}
        centered
        onOk={save}
        confirmLoading={addParent.saving}
        onCancel={() => addParent.close()}
        maskClosable={false}
      >
        <Form form={form} {...defaultFormLayout} initialValues={{ childIds: [] }}>
          <Form.Item name="childIds" label="Children" rules={[{ required: true, message: "Please select children" }]}>
            <Select mode="multiple" style={{ width: "100%" }} placeholder="Please select">
              {addParent.children.map((p) => (
                <Select.Option key={p.childId} value={p.childId}>
                  {p.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item wrapperCol={{ span: 16, offset: 8 }}>
            <Radio.Group value={addParent.isNew} onChange={(e) => onTab(e)}>
              <Radio.Button value={false}>Find Existing</Radio.Button>
              <Radio.Button value={true}>Create New</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            validateFirst={true}
            rules={[
              { required: true, message: "New user's email address is missing." },
              { type: "email", message: "Erroneous email address format." },
            ]}
          >
            {addParent.isNew ? (
              <Input placeholder="Enter user's email" />
            ) : (
              <Input.Search
                placeholder="Enter user's email"
                onSearch={(val) => {
                  addParent.findUserByEmail(val).then((users) => {
                    if (users.length > 0) {
                      form.setFieldsValue(users[0]);
                      form.setFields([
                        {
                          name: "email",
                          errors: [],
                        },
                      ]);
                    } else {
                      form.setFieldsValue({ firstName: "", lastName: "", mobile: "" });
                      form.setFields([
                        {
                          name: "email",
                          errors: [`User not found.`],
                        },
                      ]);
                    }
                  });
                }}
                allowClear
              />
            )}
          </Form.Item>
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: addParent.isNew, message: "Please input first name" }]}
          >
            <Input disabled={!addParent.isNew} maxLength={50} placeholder="Enter first name" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: addParent.isNew, message: "Please input last name" }]}
          >
            <Input disabled={!addParent.isNew} maxLength={50} placeholder="Enter last name" />
          </Form.Item>
          <Form.Item label="Mobile Number" name="mobile" rules={[AsyncValid.mobile]}>
            <NumberFormat disabled={!addParent.isNew} format="+1 (###) ###-####" mask="_" className="ant-input" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
});
